class ArrayHelperServiceClass {
  reorder(list, startIndex, endIndex) {
    if (startIndex < 0 || endIndex < 0 || startIndex >= list.length || endIndex >= list.length) {
      return undefined;
    }
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  parseStringToArrayOrUndefined(arrayString) {
    if (!arrayString) {
      return;
    }
    if (Array.isArray(arrayString)) {
      return arrayString;
    }
    if (typeof arrayString === 'string') {
      try {
        return JSON.parse(arrayString);
        // oxlint-disable-next-line no-empty
      } catch {}
    }
  }
}

export const ArrayHelperService = new ArrayHelperServiceClass();
